(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scentwear-behavior"] && !Shopify.designMode) return;
  try {
    const swUpdateSize = (select) => {
 const form = select.closest('form');
 if (!form) return;
 form.querySelector('input[name="id"]').value = select.value;
 const price = form.closest('.se-product')?.querySelector('.se-price');
 if (price) price.textContent = select.selectedOptions[0]?.dataset.price || '';
};
document.addEventListener('change', (event) => {
 if (event.target.matches('[data-card-variant]')) swUpdateSize(event.target);
});
document.addEventListener('click', (event) => {
 const sizeLink = event.target.closest('[data-size-choice]');
 if (sizeLink) document.querySelectorAll('#se-featured [data-card-variant]').forEach(select => {
  const option = Array.from(select.options).find(option => !option.disabled && option.textContent.trim().startsWith(sizeLink.dataset.sizeChoice + ' ·'));
  if (option) { select.value = option.value; swUpdateSize(select); }
 });
});
document.addEventListener('keydown', event => {
 if (event.key === 'Escape') document.querySelectorAll('.se-header details[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
});
document.addEventListener('toggle', event => {
 if (event.target.matches('.se-header details') && event.target.open) document.querySelectorAll('.se-header details[open]').forEach(other => { if (other !== event.target && !other.contains(event.target)) other.open = false; });
}, true);
const swPopup = document.querySelector('[data-scentwear-popup]');
if (swPopup) {
 const key = 'scentwear-offer-dismissed';
 const stored = () => { try { return Number(localStorage.getItem(key) || 0); } catch { return 0; } };
 const remember = () => { try { localStorage.setItem(key, String(Date.now())); } catch {} };
 let priorFocus;
 document.addEventListener('click', event => { if (event.target.closest('[data-popup-open]')) { priorFocus = event.target; swPopup.showModal(); } });
 const close = () => { remember(); swPopup.close(); priorFocus?.focus(); };
 swPopup.querySelector('[data-popup-close]')?.addEventListener('click', close);
 swPopup.addEventListener('cancel', remember);
 swPopup.addEventListener('click', event => { if (event.target === swPopup) { const rect = swPopup.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
 if (document.querySelector('[data-signup-success]')) remember();
 if (swPopup.querySelector('[data-signup-success],.errors')) { priorFocus = document.activeElement; swPopup.showModal(); }
 else if (swPopup.dataset.autoOffer === 'index' && Date.now() - stored() > 14 * 24 * 60 * 60 * 1000 && !window.Shopify?.designMode) {
  const started = Date.now();
  const show = () => {
   if (swPopup.open || Date.now() - started < 12000 || Date.now() - stored() < 14 * 24 * 60 * 60 * 1000 || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select')) return;
   if (scrollY < Math.min(500, innerHeight * .6)) return;
   priorFocus = document.activeElement;
   remember(); swPopup.showModal();
   document.removeEventListener('scroll', show);
  };
  document.addEventListener('scroll', show, {passive:true});
  setTimeout(show, 15000);
 }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scentwear-discovery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('scentwear-discovery'))customElements.define('scentwear-discovery',class extends HTMLElement{
connectedCallback(){
this.events?.abort();this.events=new AbortController();
const links=[...this.querySelectorAll('[data-edit]')],panels=[...this.querySelectorAll('[data-discovery-panel]')];
if(!links.length||panels.some(p=>!p.querySelector('.se-product')))return;
const show=key=>{links.forEach(l=>l.setAttribute('aria-current',String(l.dataset.edit===key)));panels.forEach(p=>p.hidden=p.dataset.discoveryPanel!==key);};
links.forEach(l=>l.addEventListener('click',event=>{event.preventDefault();show(l.dataset.edit);},{signal:this.events.signal}));
show('designers');this.dataset.enhanced='true';
}
disconnectedCallback(){this.events?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
